<template>
  <div class="header">
    <div class="container">
      <div class="logo">
        <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/logobai@2x.png" alt />
      </div>
      <div class="navbar">
        <div @click="navChange(item)" v-for="item,index in nav" :key='index' class="navItem" :class="{'active':item.selected}">
          <p>{{item.title}}</p>
          <img v-if="item.new" class="new" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/NEW@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      nav: [
        {title:'首页',selected:true,new:false,path:'/home'},
        {title:'业主委托',selected:false,new:false,path:'/trust'},
        {title:'关于我们',selected:false,new:false,path:'/about'},
        {title:'智鼎云商城',selected:false,new:true,path:'/shopping'},
        {title:'系统登录',selected:false,new:false,path:'/login'},
      ],
      path:''
    };
  },
  methods: {
    init() {
      this.path=this.$route.path;
      console.log(this.path)
      this.nav.forEach(item=>{
        if(this.path=='/'){
          this.nav[0].selected=true
          return false
        }
        if(this.path.indexOf(item.path)!=-1){
          item.selected=true
        }else{
          item.selected=false
        }
      })
    },
    navChange(val){
      let arr=this.nav.map(item=>{
        if(item.title==val.title){
          item.selected=true;
        }else{
          item.selected=false;
        }
        return item
      })
      this.nav=arr
      if(val.path=='/login'){
        const { href } = this.$router.resolve({
            name: "登录",
        });
        window.open(href, '_blank');
      }else{
        this.$router.push(val.path);
      }
      
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang='less' scoped>
@import "~style/index";
img {
  width: 100%;
  object-fit: contain;
}
.header {
  width: 100%;
  height: 110px;
  background: rgba(67, 69, 84, 1);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.17);
  .container {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 180px;
    }
  }
  .navbar{
    display: flex;
    align-items: center;
    height:110px;
    .navItem{
      position: relative;
      margin-right:20px;
      p{
        margin:0;
        line-height: 110px;
        color:white;
        font-size:20px;
        cursor: pointer;
      }  
      &.active::after{
        content:'';
        position: absolute;
        bottom:32px;
        display: block;
        width:60px;
        height:3px;
        background: #FF7A32;
        left:50%;
        transform: translateX(-50%);
      }
      .new{
        position: absolute;
        width: 40px;
        right:-20px;
        top:20px;
        // transform: translate(50%,-20px);
      }
    }
    
  }
}
</style>